// removed by extract-text-webpack-plugin
module.exports = {"title":"_3SrIQ"};


//////////////////
// WEBPACK FOOTER
// ./app/components/header-title/header-title.scss
// module id = 1500
// module chunks = 0